import { Link } from "@shopify/polaris";
import { useNavigate } from "react-router-dom";

interface UpgradeLinkProps {
	/** Plain-language description of what becomes unlocked, e.g. "OpenAI" or "more languages". */
	unlocks: string;
	/** Target plan name shown in the CTA. */
	targetPlan?: string;
}

/**
 * Inline "Upgrade to {plan} to unlock {unlocks}" link used next to locked
 * Configuration controls. Deep-links to the existing /plans route.
 */
export function UpgradeLink({ unlocks, targetPlan = "Growth" }: UpgradeLinkProps) {
	const navigate = useNavigate();
	return (
		<Link
			onClick={() => navigate("/plans")}
			removeUnderline={false}
			monochrome={false}
		>
			Upgrade to {targetPlan} to unlock {unlocks}.
		</Link>
	);
}
